import { gql } from '@apollo/client';

export const GET_VOLUNTEER_DATABASE_TASKS = gql`
  query GetVolunteerDatabaseTasks {
    vm {
      tasks {
        ...VolunteerDatabaseTasks
      }
    }
  }
  fragment VolunteerDatabaseTasks on VOLUNTEER_TaskType {
    taskId
    title
    description
    order
    cake {
      cakeType
    }
    taskItems {
      ... on VOLUNTEER_TaskItemFieldType {
        field {
          taskFieldId
          name
          description
        }
      }
    }
  }
`;
